import React from "react"
import { useHistory } from "react-router-dom"
import { ArrowLeft, Menu, Search, Sliders } from "react-feather"

/**
 * Mobil sarlavha paneli.
 *
 * Chapda orqaga qaytish yoki menyu, o'rtada sahifa nomi, o'ngda
 * qidiruv va filtr. Tugmalar faqat kerak bo'lganda chiqadi — bo'sh
 * ikonka bosilmaydigan bezak bo'lib qolmasin.
 */
export default function MobileHeader({
  title,
  showBack,
  onSearch,
  onFilter,
  filterActive,
  onMenu,
}: {
  title: React.ReactNode
  showBack?: boolean
  onSearch?: () => void
  onFilter?: () => void
  filterActive?: boolean
  onMenu?: () => void
}) {
  const history = useHistory()

  return (
    <header className="mb-header">
      <div className="mb-header-side">
        {showBack ? (
          <button type="button" aria-label="back" onClick={() => history.goBack()}>
            <ArrowLeft size={20} />
          </button>
        ) : (
          <button type="button" aria-label="menu" onClick={onMenu}>
            <Menu size={20} />
          </button>
        )}
      </div>

      <div className="mb-header-title">{title}</div>

      <div className="mb-header-side mb-header-side--right">
        {onSearch && (
          <button type="button" aria-label="search" onClick={onSearch}>
            <Search size={19} />
          </button>
        )}
        {onFilter && (
          <button
            type="button"
            aria-label="filter"
            className={filterActive ? "mb-active" : ""}
            onClick={onFilter}
          >
            <Sliders size={19} />
          </button>
        )}
      </div>
    </header>
  )
}
